import {
  type PasswordSignContractMutationVariables,
  usePasswordSignContractMutation,
} from 'api/core/generated';
import { AppApiVersions } from 'app-constants';

export const useSignContractWithPassword = () => {
  const [passwordSigningRequest, { data, loading, error }] =
    usePasswordSignContractMutation({
      context: { apiVersion: AppApiVersions.core },
    });

  const signContractWithPassword = (
    variables: PasswordSignContractMutationVariables,
  ) => passwordSigningRequest({ variables });

  return {
    signContractWithPasswordProcessing: loading,
    signContractWithPasswordError: error,
    signContractWithPasswordSuccess: data?.success,
    signContractWithPassword,
  };
};
